export default {
  getRoles: (state) => state.roles,
  getRole: (state) => state.role,
};
